import e from "prop-types";
import d from "react";
import o from "classnames";
import './Paper.css';const r = "Paper-module__paper___eG5-l", l = "Paper-module__depth___-TYiU", a = "Paper-module__depth_0___1bj-r", h = "Paper-module__depth_1___kuw1J Paper-module__depth___-TYiU", s = "Paper-module__depth_2___eD2O8 Paper-module__depth___-TYiU", m = "Paper-module__depth_3___5TWUj Paper-module__depth___-TYiU", n = "Paper-module__depth_4___LrpjQ Paper-module__depth___-TYiU", c = "Paper-module__depth_5___mvM1N Paper-module__depth___-TYiU", t = {
  paper: r,
  depth: l,
  depth_0: a,
  depth_1: h,
  depth_2: s,
  depth_3: m,
  depth_4: n,
  depth_5: c
};
function p(_) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ d.createElement(
      "div",
      {
        className: o(
          [t.paper, t[`depth_${_.depth}`]],
          _.className
        ),
        style: _.style,
        onClick: _.onClick
      },
      _.children
    )
  );
}
p.propTypes = {
  /** The content */
  children: e.node,
  /** class name(s) */
  className: e.oneOfType([
    e.string,
    e.arrayOf(e.string)
  ]),
  /** depth of card */
  depth: e.number,
  /** function to be called on click */
  onClick: e.func,
  /** additional styles object */
  // eslint-disable-next-line react/forbid-prop-types
  style: e.object
};
p.defaultProps = {
  children: null,
  className: void 0,
  depth: 0,
  onClick: void 0,
  style: {}
};
export {
  p as P
};
